import { useEffect } from "react";

export default function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title
      ? `${title} - 甜心剧情站`
      : "守护甜心动漫分集剧情｜全集剧情解析与结局详解 - 甜心剧情站";
  }, [title]);
}